<template>
  <span :class="[
          `icon-${icon}${fill ? '-bold' : ''}`,
          props.disabled && '!tw-text-blue-dark-100',
          (props.pointer && !props.disabled) && '!tw-cursor-pointer'
        ]"
        @click="handleClick"
        :style="{ 'font-size': `${size}px`}"></span>
</template>

<script setup>
const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
  fill: {
    type: Boolean,
    default: false,
  },
  size: {
    type: [Number, String],
    default: 24,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  pointer: {
    type: Boolean,
    default: false,
  }
});

const emit = defineEmits(["click"])
const handleClick = (event) => {
  if (props.disabled) {
    event.stopPropagation()
    return false
  }

  emit("click", event)
}
</script>

<style lang="scss" scoped></style>
